// =============================================================
// mapOverlays.js — Mapbox Directions helper (route building / snap-to-road)
//
// NOTE: basemap + raster/vector overlays (contours, terrain, FEMA flood, USGS,
// USDA, etc.) are provided by the shared layer catalog in
// utils/mapLayerEngine.js + constants/mapLayers.js + MapLayerCatalog.jsx.
// This module only keeps the Directions API helper used by the route builder.
// =============================================================

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || '';

// ── Mapbox Directions — route building / snap-to-road ───────
// coords: [[lng,lat], ...] (2+). Returns a GeoJSON LineString geometry or null.
export async function fetchDirections(coords, profile = 'driving') {
  if (!MAPBOX_TOKEN || !coords || coords.length < 2) return null;
  const path = coords.map(c => `${c[0]},${c[1]}`).join(';');
  const url = `https://api.mapbox.com/directions/v5/mapbox/${profile}/${encodeURIComponent(path)}` +
    `?geometries=geojson&overview=full&access_token=${MAPBOX_TOKEN}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Directions request failed (${res.status})`);
  const json = await res.json();
  return json.routes?.[0]?.geometry || null;
}
